__webpack_require__.p = "/bangla-typing/_next/";